import { render, staticRenderFns } from "./LinkageLogs.vue?vue&type=template&id=326131f1&"
import script from "./LinkageLogs.vue?vue&type=script&lang=js&"
export * from "./LinkageLogs.vue?vue&type=script&lang=js&"
import style0 from "./LinkageLogs.vue?vue&type=style&index=0&id=326131f1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports